function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AppScore from './AppScore';
import AppManagement from '../AppManagement';
import SvgFilterMixin from '../SvgFilterMixin';
export default {
  name: 'AppItem',
  components: {
    AppScore: AppScore
  },
  mixins: [AppManagement, SvgFilterMixin],
  props: {
    app: {},
    category: {},
    listView: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isSelected: false,
      scrolled: false
    };
  },
  computed: {
    hasRating: function hasRating() {
      return this.app.appstoreData && this.app.appstoreData.ratingNumOverall > 5;
    }
  },
  watch: {
    '$route.params.id': function $routeParamsId(id) {
      this.isSelected = this.app.id === id;
    }
  },
  mounted: function mounted() {
    this.isSelected = this.app.id === this.$route.params.id;
  },
  watchers: {},
  methods: {
    showAppDetails: function showAppDetails(event) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(event.currentTarget.tagName === 'INPUT' || event.currentTarget.tagName === 'A')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return _this.$router.push({
                  name: 'apps-details',
                  params: {
                    category: _this.category,
                    id: _this.app.id
                  }
                });

              case 5:
                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 7]]);
      }))();
    },
    prefix: function prefix(_prefix, content) {
      return _prefix + '_' + content;
    }
  }
};